import {
    TablePagination,
    Theme
} from "@mui/material";
import {
    CaretDownIcon,
    PaginationNextIcon,
    PaginationPreviousIcon
} from "../../../../assets/SvgIcons";

export default function TablePaginationComponent(
    {
        tableDataCount,
        handlePageChange,
        handleRowsPerPageChange,
        rowsPerPageOptions = [10, 20, 30],
        rowsPerPage = 10,
        currentPage = 0
    }: {
        tableDataCount: number,
        handlePageChange: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void,
        handleRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
        rowsPerPageOptions?: number[]
        rowsPerPage?: number;
        currentPage?: number;
    }
): JSX.Element {
    return (
        <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={tableDataCount}
            rowsPerPage={rowsPerPage}
            page={currentPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            slotProps={{
                select: {
                    IconComponent: CaretDownIcon
                }
            }}
            // slots={{
            //     actions: {
            //         nextButtonIcon: PaginationNextIcon,
            //         previousButtonIcon: PaginationPreviousIcon
            //     }
            // }}
            sx={(theme: Theme) => ({
                "& .MuiTablePagination-toolbar": {
                    "& .MuiTablePagination-selectLabel": {
                        ...theme.typography.subtitle_400,
                        color: theme.palette.text.primary,
                    },
                    "& .MuiTablePagination-displayedRows": {
                        ...theme.typography.subtitle_400,
                        color: theme.palette.text.primary,
                        marginBottom: "13px"
                    },
                    "& .MuiTablePagination-input": {
                        "& .MuiTablePagination-select": {
                            paddingTop: "10px",
                            ...theme.typography.subtitle_400,
                            color: theme.palette.text.primary,
                            // Re-enable focus ring that MuiSelect suppresses globally.
                            // Target .MuiSelect-select (the actual focusable element inside
                            // the TablePagination select slot) via both :focus and :focus-visible.
                            "&.MuiSelect-select:focus, &.MuiSelect-select:focus-visible": {
                                outline: `2px solid #a33d18 !important`,
                                outlineOffset: "2px",
                                borderRadius: "4px",
                                backgroundColor: "transparent",
                            },
                        },
                        "& .MuiTablePagination-selectIcon": {
                            color: theme.palette.text.primary
                        }
                    },
                    // Ensure next/previous page icon buttons have matching focus ring
                    "& .MuiTablePagination-actions button": {
                        "&:focus-visible, &.Mui-focusVisible": {
                            outline: `2px solid #a33d18 !important`,
                            outlineOffset: "2px",
                            borderRadius: "4px",
                        },
                    },
                }
            })}
        />
    )
}